import ReactGA from "react-ga4";

ReactGA.initialize("G-K6QZN5WHMC");

export { ReactGA };
